import { render, staticRenderFns } from "./UserDetailsAdministrationTabs.vue?vue&type=template&id=0580fa5f&"
import script from "./UserDetailsAdministrationTabs.vue?vue&type=script&lang=js&"
export * from "./UserDetailsAdministrationTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports